module.exports = __webpack_public_path__ + "static/media/space-logo-white.1c20464f.webp";